<template>
  <v-container>
    <h3>目標設定</h3>

    <v-dialog v-model="showDialog" :fullscreen="true">
      <edit-user  :target_id="target_id" @closeDialog="closeDialog" @createItem="createItem" />
    </v-dialog>
    <v-data-table
      :items="challangeSheets"
      :headers="headers"
      class="elevation-1"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      rows-per-page-text="表示行"
    >
      <template slot="items" slot-scope="props">
        <tr @click="toChallangeSheet(props.item)">
          <td>{{props.item.name}}</td>
          <td>{{props.item.job}}</td>
          <td>{{props.item.position}}</td>
          <td>{{props.item.status}}</td>
          <td>
            <v-btn icon @click="deleteItem(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
    </v-data-table>
  </v-container>
</template>
<script>
import db from "@/components/firebaseInit";
import EditUser from "@/components/manage_survey/editUserForTarget.vue";
import {
  getUnixtime,
  unixtimeToJapaneseFormattedDate
} from "@/utils/datetime.js";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { EditUser },
  props: {
    target_id: {
      type: String,
      default: ""
    },
    challangeSheets: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      items: [],
      headers: [
        { text: "対象者名", value: "subject_name", sortable: true },
        { text: "職種", value: "job", sortable: false },
        { text: "役職", value: "position", sortable: false },
        { text: "ステータス", value: "status", sortable: true },
        { text: "操作", sortable: false }
      ],
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets"),
      mailDbRef: db.collection("mails"),
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("challenge_sheets")
        .where("survey_id", "==", this.$route.params.survey_id),
      showDialog: false,
      selectedItems: {},
      subject: {},
      rowsPerPageItems: [25, 50, 100],
      pagination: {
        rowsPerPage: 25
      },
      showUrl: false,
      showSendMail: false,
      selectedUrl: "",
      mailBody: "山岸様 \r\n URLを再送します。",
      mailSubject: "サーベイURLの再送",
    };
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    async deleteItem(item) {
      await this.dbRef
        .doc(item.id)
        .delete()
        .catch(e => {
          console.error("Error removing document: ", e);
        });
        this.updateItems()
    },
    async createItem(item){
      try {
        await this.dbRef.add(item);
        this.changeLoadingState(false) 
        this.updateItems()
        this.closeDialog();
      } catch (e) {
        console.error(e);
        this.changeLoadingState(false) 
      }
      finally{
        this.changeLoadingState(false) 
      }
    },
    closeDialog(){
      this.showDialog = false
    },
    updateItems(){
      this.$emit('updateItems')
    },
       toChallangeSheet(item) {
            this.$router.push({ name: "target", params: { company_id: this.$route.params.company_id, sheet_id: item.id } })

        },

    ...mapActions("app", ["changeLoadingState"])
  }
};
</script>

<style lang="scss" scoped>

.line-break { word-wrap: break-all; }

</style>
